import React, { useMemo, useState } from 'react';
import {
  Button, Dialog, DialogActions, DialogTitle,
} from '@mui/material';
import PropTypes from 'prop-types';

function Question({
  children,
  questionText,
  actions,
  actionHandler,
}) {
  const [opened, setOpened] = useState(false);
  const NewButton = useMemo(
    () => React.cloneElement(
      React.Children.only(children),
      { onClick: () => setOpened(true) },
    ),
    [children],
  );
  return (
    <>
      {NewButton}
      <Dialog open={opened}>
        <DialogTitle>
          {questionText}
        </DialogTitle>
        <DialogActions>
          {actions.map((action) => (
            <Button
              variant="contained"
              title={action.label}
              key={`Action${action.value}`}
              onClick={(e) => {
                setOpened(false);
                actionHandler(e, action.value);
              }}
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      </Dialog>
    </>
  );
}

Question.propTypes = {
  children: PropTypes.element.isRequired,
  questionText: PropTypes.string.isRequired,
  actions: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  })).isRequired,
  actionHandler: PropTypes.func.isRequired,
};

export default Question;
